(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    #abortController = new AbortController();

    connectedCallback() {
      this.statusElement = this.querySelector('[data-product-gallery-status]');
      this.mediaItems = Array.from(this.querySelectorAll('[data-product-gallery-item]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-product-gallery-thumbnail]'));

      if (this.thumbnails.length <= 1) return;

      const { signal } = this.#abortController;

      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', this.#onThumbnailClick, { signal });
        thumbnail.addEventListener('keydown', this.#onThumbnailKeydown, { signal });
      });
    }

    disconnectedCallback() {
      this.#abortController.abort();
    }

    #onThumbnailClick = (event) => {
      const thumbnail = event.currentTarget;
      const index = Number(thumbnail.dataset.productGalleryThumbnail);
      this.#setActive(index);
    };

    #onThumbnailKeydown = (event) => {
      const currentIndex = this.thumbnails.indexOf(event.currentTarget);
      let nextIndex;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = (currentIndex + 1) % this.thumbnails.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = (currentIndex - 1 + this.thumbnails.length) % this.thumbnails.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.thumbnails.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.thumbnails[nextIndex].focus();
      this.#setActive(nextIndex);
    };

    #setActive(index) {
      this.mediaItems.forEach((item, i) => {
        if (i === index) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });

      this.thumbnails.forEach((thumbnail, i) => {
        if (i === index) {
          thumbnail.setAttribute('aria-current', 'true');
          thumbnail.setAttribute('tabindex', '0');
        } else {
          thumbnail.removeAttribute('aria-current');
          thumbnail.setAttribute('tabindex', '-1');
        }
      });

      this.#announce(index);
    }

    #announce(index) {
      if (!this.statusElement) return;

      const total = this.thumbnails.length;
      const template = this.dataset.announceTemplate ?? 'Image [INDEX] of [TOTAL]';
      this.statusElement.textContent = template.replace('[INDEX]', index + 1).replace('[TOTAL]', total);
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
